import { Icon, forwardRef } from "@chakra-ui/react";
import * as React from "react";
export const SvgVsCodeLogoIcon = forwardRef((props, ref) => {
  return /* @__PURE__ */ React.createElement(Icon, { ref, color: "foreground.secondary", fill: "none", focusable: "false", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.5 1.5L14 3v10l-2.5 1.5L5 9.8l-2.6 2L1 11l2.6-3L1 5l1.4-.8 2.6 2 6.5-4.7zM11 5.2L7.6 8 11 10.8V5.2z", fill: "#0078D4" }));
});
export default SvgVsCodeLogoIcon;
